export default __webpack_public_path__ + "static/media/Newsec.b637a0ad.png";